// ShortcutHelp modal (Unit 36d, spec §11.12).
//
// Full-screen modal opened by `?`. Lists every shortcut grouped by context.
// Copy reads from i18n so the modal renders in the active UI language.

import { useTranslation } from "react-i18next";

import "./ShortcutHelp.css";

interface Row {
  keys: string[];
  i18nKey: string;
}

const GLOBAL: Row[] = [
  { keys: ["?"], i18nKey: "shortcut.help_title" },
  { keys: ["Esc"], i18nKey: "shortcut.esc" },
  { keys: ["⌘", "K"], i18nKey: "shortcut.cmd_k" },
  { keys: ["T"], i18nKey: "shortcut.t" },
];

const TREE: Row[] = [
  { keys: ["↑", "↓"], i18nKey: "shortcut.tree_arrow" },
  { keys: ["Enter"], i18nKey: "shortcut.tree_enter" },
  { keys: ["Space"], i18nKey: "shortcut.tree_space" },
  { keys: ["⌘", "N"], i18nKey: "shortcut.tree_new" },
  { keys: ["⌘", "I"], i18nKey: "shortcut.tree_import" },
];

const REVIEW: Row[] = [
  { keys: ["J", "K"], i18nKey: "shortcut.review_jk" },
  { keys: ["A"], i18nKey: "shortcut.review_a" },
  { keys: ["D"], i18nKey: "shortcut.review_d" },
  { keys: ["E"], i18nKey: "shortcut.review_e" },
  { keys: ["C"], i18nKey: "shortcut.review_c" },
  { keys: ["←", "→"], i18nKey: "shortcut.review_arrow" },
  { keys: ["R"], i18nKey: "shortcut.review_r" },
  { keys: ["M"], i18nKey: "shortcut.review_m" },
  { keys: ["⌘", "F"], i18nKey: "shortcut.review_cmd_f" },
  { keys: ["⌘", "Enter"], i18nKey: "shortcut.review_cmd_enter" },
  { keys: ["⌘", "E"], i18nKey: "shortcut.review_cmd_e" },
];

export function ShortcutHelp({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="shortcut-help-backdrop" onClick={onClose}>
      <div className="shortcut-help" onClick={(e) => e.stopPropagation()}>
        <header className="shortcut-help__header">
          <h2>{t("shortcut.help_title")}</h2>
          <button type="button" className="shortcut-help__close" onClick={onClose}>
            ✕
          </button>
        </header>
        <Section title={t("navigator.title")} rows={GLOBAL.concat(TREE)} />
        <Section title={t("paper_review.scan")} rows={REVIEW} />
      </div>
    </div>
  );
}

function Section({ title, rows }: { title: string; rows: Row[] }) {
  const { t } = useTranslation();
  return (
    <section className="shortcut-help__section">
      <h3>{title}</h3>
      <ul>
        {rows.map((row, i) => (
          <li key={i}>
            <span className="shortcut-help__keys">
              {row.keys.map((k, j) => (
                <kbd key={j}>{k}</kbd>
              ))}
            </span>
            <span>{t(row.i18nKey)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
